module.exports = __webpack_public_path__ + "assets/img/staticinfo.21ae2226.svg";